import React from 'react';
import styled from 'styled-components';

interface Props {
	body: string;
	mentionedUsers: Record<string, string>;
}

const Wrapper = styled.span`
	white-space: pre-wrap;
`;

const MentionPill = styled.span`
	display: inline-flex;
	align-items: center;
	border-radius: 4px;
	background: #eff6ff;
	padding: 0 4px;
	${p => p.theme.sys.font?.subheading?.['2']}
	color: #1d4ed8;
`;

// Matches both @[user:<id>] (canonical) and @[<id>] (legacy)
const MENTION_DISPLAY_RE = /@\[(?:user:)?([^\]]+)\]/g;

export function MentionText({body, mentionedUsers}: Props) {
	const parts: React.ReactNode[] = [];
	let lastIndex = 0;
	let match: RegExpExecArray | null;

	MENTION_DISPLAY_RE.lastIndex = 0;

	while ((match = MENTION_DISPLAY_RE.exec(body)) !== null) {
		const beforeText = body.slice(lastIndex, match.index);
		if (beforeText) {
			parts.push(beforeText);
		}

		const userId = match[1]!;
		const displayName = mentionedUsers[userId] ?? userId;

		parts.push(
			<MentionPill key={`${userId}-${match.index}`} title={userId}>
				@{displayName}
			</MentionPill>
		);

		lastIndex = match.index + match[0].length;
	}

	const remaining = body.slice(lastIndex);
	if (remaining) {
		parts.push(remaining);
	}

	return <Wrapper>{parts}</Wrapper>;
}
